import { ReactNode } from 'react'
import { LoaderContainer, Spinner, LoaderNoMarginContainer, FullScreen } from './styles'

export interface LoaderProps {
  children?: ReactNode
  small?: boolean
  noMargin?: boolean
}

export function Loader({ small, noMargin }: LoaderProps) {
  if (noMargin !== undefined) {
    return (
      <LoaderNoMarginContainer>
        <Spinner small={small} />
      </LoaderNoMarginContainer>
    )
  }
  return (
    <LoaderContainer>
      <Spinner small={small} />
    </LoaderContainer>
  )
}

export const FullLoader = () => {
  return (<FullScreen>
    <Loader />
  </FullScreen>)
}

export default Loader
